var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloudIconPhoneLanding(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 27.2223H8.33341V25.5557H10.0001V27.2223Z",
    fill: "#474350"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0001 27.2223H31.6667V25.5557H30.0001V27.2223Z",
    fill: "#474350"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 18.889H18.3334V20.5557H16.6667V18.889Z",
    fill: "#474350"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 17.2223H15.0001V18.889L16.6667 18.889V17.2223Z",
    fill: "#474350"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 17.2223L8.33341 17.2223V18.889H10.0001V17.2223Z",
    fill: "#474350"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6667 18.889H28.3334V20.5557H26.6667V18.889Z",
    fill: "#474350"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6667 13.889L25.0001 13.889V12.2223H26.6667V13.889Z",
    fill: "#474350"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6667 17.2223L28.3334 17.2223V13.889L26.6667 13.889V17.2223Z",
    fill: "#474350"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0001 12.2223V10.5557L16.6667 10.5557V12.2223H25.0001Z",
    fill: "#474350"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 12.2223H15.0001V15.5557L16.6667 15.5557V12.2223Z",
    fill: "#474350"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 15.5557V17.2223L15.0001 17.2223V15.5557L10.0001 15.5557Z",
    fill: "#474350"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66675 25.5557H8.33341V18.889H6.66675V25.5557Z",
    fill: "#474350"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 27.2223V28.889H30.0001V27.2223H10.0001Z",
    fill: "#474350"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6667 25.5557H33.3334V18.889L31.6667 18.889V25.5557Z",
    fill: "#474350"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6667 18.889V17.2223H28.3334V18.889L31.6667 18.889Z",
    fill: "#474350"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0002 12.2224H16.6668V15.5557H15.0002V17.2224H10.0002V18.8891H8.3335V25.5557H10.0002V27.2224H30.0002V25.5557H31.6668V18.8891H28.3335V17.2224H26.6668V13.8891H25.0002V12.2224ZM28.3335 18.8891V20.5557H26.6668V18.8891H28.3335ZM16.6668 18.8891H15.0002V17.2224H16.6668V18.8891ZM16.6668 18.8891H18.3335V20.5557H16.6668V18.8891Z",
    fill: "#FFFFF3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudIconPhoneLanding);
export default __webpack_public_path__ + "static/media/cloud_icon_phone_landing.284d5d60e51d8872a9441edcc45606f7.svg";
export { ForwardRef as ReactComponent };